import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import type { IApiUnpublishArticleResponseBody } from '../ArticlesApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseUnpublishArticleMutationValues = {
  appId: string;
  articleId: string;
};

export const useUnpublishArticleMutation = (): UseMutationResult<
  IApiUnpublishArticleResponseBody,
  unknown,
  IUseUnpublishArticleMutationValues
> => {
  const api = useApi();

  return useMutation({
    mutationFn: (values: IUseUnpublishArticleMutationValues) =>
      api.articles.unpublish(values.appId, values.articleId),
    // TODO once the API is updated to return the unpublished article object
    // onSuccess: async (unpublishedArticle) => {
    //   await Promise.all(
    //     (unpublishedArticle.categoriesId ?? [])
    //       .map((categoryId) => ({
    //         queryKey: articlesQueryKeyFactory({
    //           appId: values.appId,
    //           categoryId,
    //         }),
    //       }))
    //       .map((filters) => queryClient.invalidateQueries(filters)),
    //   );
    // },
  });
};
